<template>
    <div class="wrap-document">
        <div class="page">
            <p class="title">
                PERNYATAAN PENGUNGKAPAN <br />
                (<i> DISCLOSURE STATEMENT </i>)
            </p>
            <div class="content">
                <ol>
                    <li>
                        Perdagangan Berjangka BERISIKO SANGAT TINGGI tidak cocok untuk semua orang. Pastikan bahwa anda SEPENUHNYA MEMAHAMI RISIKO ini sebelum
                        melakukan perdagangan.
                    </li>
                    <li>
                        Perdagangan Berjangka merupakan produk keuangan dengan leverage dan dapat menyebabkan KERUGIAN ANDA MELEBIHI setoran awal Anda. Anda harus
                        siap apabila SELURUH DANA ANDA HABIS.
                    </li>
                    <li>
                        TIDAK ADA PENDAPATAN TETAP (FIXED INCOME) dalam Perdagangan Berjangka
                    </li>
                    <li>
                        Apabila anda PEMULA kami sarankan untuk mempelajari mekanisme transaksinya, PERDAGANGAN BERJANGKA membutuhkan pengetahuan dan pemahaman
                        khusus.
                    </li>
                    <li>
                        ANDA HARUS MELAKUKAN TRANSAKSI SENDIRI, segala risiko yang akan timbul akibat transaksi sepenuhnya akan menjadi tanggung jawab Saudara.
                    </li>

                    <li>
                        user id dan password BERSIFAT PRIBADI DAN RAHASIA, anda bertanggung jawab atas penggunaannya, JANGAN SERAHKAN ke pihak lain terutama Wakil
                        Pialang Berjangka dan pegawai Pialang Berjangka.
                    </li>
                    <li>
                        ANDA berhak menerima LAPORAN ATAS TRANSAKSI yang anda lakukan. Waktu anda 2 X 24 JAM UNTUK MEMBERIKAN SANGGAHAN. Untuk transaksi yang TELAH
                        SELESAI (DONE/SETTLE) DAPAT ANDA CEK melalui sistem informasi transaksi nasabah yang berfungsi untuk memastikan transaksi anda telah
                        terdaftar di Lembaga Kliring Berjangka.
                    </li>
                </ol>
            </div>

            <!-- <div class="content">
        Dengan mengisi kolom “YA” di bawah ini, saya menyatakan bahwa saya telah melakukan simulasi bertransaksi di bidang Perdagangan Berjangka Komoditi pada PT.ABI
        Komoditi Berjangka, dan telah memahami tentang tata cara bertransaksi di bidang Perdagangan Berjangka Komoditi.
        <form>
          <div class="form-group"></div>
        </form>
      </div>
      <div class="content">
        Demikian Pernyataan ini dibuat dengan sebenarnya dalam keadaan sadar, sehat jasmani dan rohani serta tanpa paksaan apapun dari pihak manapun
        <form>
          <div class="form-group"></div>
        </form>
      </div> -->

            <div class="persetujuan">
                <div class="ttd">
                    <p>Pernyataan menerima</p>
                    <div class="pernyataan">
                        <input type="radio" name="confirm" v-model="setValue" :value="true" required @change="handleValue" />
                        <label>Ya</label>
                        <input type="radio" :value="false" v-model="setValue" @change="handleValue" />
                        <label>Tidak</label>
                    </div>
                </div>
                <div class="ttd">
                    <p>Menerima pada Tanggal</p>
                    <div>
                        {{ currentDate | formatDateTime }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        fullName: String,
        dataPrint: Object,
        disclosureValue: Boolean,
    },
    data() {
        return {
            currentDate: "",
        };
    },
    mounted() {
        if (this.dataPrint) {
            this.currentDate = this.dataPrint.tanggal_diterima;
        } else {
            this.currentDate = new Date();
        }
    },
    computed: {
        setValue() {
            return this.disclosureValue;
        },
    },
    methods: {
        handleValue(e) {
            this.$emit("updateValue", e.target._value);
        },
    },
};
</script>

<style scoped>
label {
    width: 8rem;
}

.format-text {
    text-transform: capitalize;
    padding: 0px 0.5rem;
}

.format-text::first-letter,
.format-text::first-line {
    text-transform: capitalize;
}

.wrap-document {
    /* width: 210mm; */
    padding-inline: 1cm;
    height: 276.5mm;
    /* padding: 10mm; */
    margin: 0.5mm auto;
    /* border: 1px red solid; */
    border-radius: 5px;
    background: white;
    /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
    position: relative;
}

/* .wrap-document {
    padding: 20px;
    border-radius: 5px;
    background: white;
    position: relative;
    color: black;
} */

li {
    margin-bottom: 0.5rem;
}

.tanda-tangan {
    width: 80%;
    text-align: center;
}

.top {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
}

.header {
    display: flex;
    justify-content: space-between;
    font-size: 10px;
    margin-bottom: 25px;
}

.nomor {
    font-weight: bold;
}

.lampiran p {
    margin: 0;
    text-align: right;
}

.title {
    font-weight: bold;
    text-align: center;
    font-size: 14px;
    margin-bottom: 2rem;
}

.content {
    font-size: 12px;
    text-align: justify;
}

.sub-content {
    font-weight: 700;
}

form {
    margin: 20px 0;
    text-align: right;
    font-weight: 700;
}

label {
    margin-right: 15px;
}

.persetujuan {
    width: 50%;
    font-size: 13px;
    margin: 2rem auto;
}

.persetujuan .ttd {
    display: flex;
    gap: 1rem;
}

.persetujuan .ttd p {
    width: 10rem;
}

.pernyataan input {
    margin-right: 0.6rem;
}

.pernyataan label {
    width: 2rem;
}

@page {
    size: A4;
    margin: 0;
}

@media (max-width: 768px) {
    .wrap-document {
        width: 100%;
        padding: 30px 0;
    }

    .title {
        margin: 20px auto !important;
    }

    .page {
        padding: 0;
    }

    .persetujuan {
        width: 100%;
    }
}
</style>
